import React from 'react';
import { Button } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { useRouter } from 'next/router';
import { useWeb3Context } from '../../providers/Web3Provider/useWeb3Context';
import { useMultipass, generateInputProps } from '../../hooks/useMultipass';
import { Fellowship } from '../../types/fellowship';

interface FellowshipGardenButtonProps {
  fellowship: Fellowship;
}

export const FellowshipGardenButton = ({ fellowship }: FellowshipGardenButtonProps) => {
  const router = useRouter();
  const web3Context = useWeb3Context();

  // Check if user has multipass registered for Fellowship Garden
  const multipassService = useMultipass(
    generateInputProps({
      web3ProviderContext: web3Context,
      domainName: fellowship.multipassDomain,
    })
  );

  const isMember = multipassService.isRecordResolutionFetched && multipassService.hasMultipassRegistered === true;
  const isLoading = !multipassService.isRecordResolutionFetched;

  // Show nothing if not a member and not loading
  if (!isMember && !isLoading) {
    return null;
  }

  return (
    <Button
      size="lg"
      variant="filled"
      color="teal"
      leftSection={!isLoading && <IconSparkles size={27} />}
      onClick={() => router.push('/invisible-garden')}
      fullWidth={false}
      w={{ base: '100%', xs: 'auto' }}
      loading={isLoading}
      disabled={isLoading}
    >
      Invisible Garden
    </Button>
  );
};
